module.exports = __webpack_public_path__ + "static/img/162_phase_function_Paper_PointsHejduk_Prediction.925cd51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/162_phase_function_Paper_PointsHejduk_Prediction.png
// module id = E6DU
// module chunks = 0